import { useEffect, useState, useCallback } from "react";
import { getSheetAttachments } from "../services/api/attachments/attachments.api";

export function useSheetAttachments({
  contentId,
  scope = "ProjectSheet",
  pageSize = 9999,
}) {
  const [attachments, setAttachments] = useState([]);
  const [dataContentId, setDataContentId] = useState(null);
  const [loadingAttachments, setLoadingAttachments] = useState(false);
  const [error, setError] = useState(null);

  const fetchAttachments = useCallback(() => {
    if (!contentId) {
      setDataContentId(null);
      return;
    }

    setLoadingAttachments(true);
    setError(null);

    return getSheetAttachments({ contentId, scope, pageSize })
      .then((response) => {
        const data = response?.data ?? response;
        setAttachments(data);
        setLoadingAttachments(false);
        setDataContentId(contentId);
      })
      .catch((err) => {
        setError(err);
        setLoadingAttachments(false);
      });
  }, [contentId, scope, pageSize]);

  useEffect(() => {
    fetchAttachments();
  }, [fetchAttachments]);

  const safeAttachments = dataContentId === contentId ? attachments : [];

  return {
    attachments: safeAttachments,
    loadingAttachments,
    error,
    refetchAttachments: fetchAttachments,
  };
}
